export interface TemplateColumnConfig {
  key: string;
  label: string;
  required?: boolean;
  type?: 'string' | 'number' | 'date' | 'enum' | 'array' | 'object';
  enumValues?: string[];
}

export interface DownloadTemplateSheetConfig {
  name: string;
  columns: TemplateColumnConfig[];
  rows: any[];
  dropdowns?: Record<string, string[]>;
}

export const QUESTION_TEMPLATE_CONFIG: TemplateColumnConfig[] = [
  { key: 'title', label: 'Title', required: true, type: 'string' },
  { key: 'fullText', label: 'Full Text', required: true, type: 'string' },
  { key: 'category', label: 'Category', required: true, type: 'string' },
  {
    key: 'level',
    label: 'Difficulty',
    required: true,
    type: 'enum',
    enumValues: ['Easy', 'Medium', 'Hard'],
  },
  { key: 'tags', label: 'Tags', required: false, type: 'array' },
  { key: 'subject', label: 'Subject', required: true, type: 'string' },
  { key: 'optionA', label: 'Option A', required: true, type: 'string' },
  { key: 'optionB', label: 'Option B', required: true, type: 'string' },
  { key: 'optionC', label: 'Option C', required: false, type: 'string' },
  { key: 'optionD', label: 'Option D', required: false, type: 'string' },
  {
    key: 'answerOption',
    label: 'Answer Option',
    required: true,
    type: 'string',
  },
  { key: 'solution', label: 'Solution', required: false, type: 'string' },
];

export const ASSIGNMENT_TEMPLATE_CONFIG: TemplateColumnConfig[] = [
  { key: 'name', label: 'Name', required: true, type: 'string' },
  { key: 'course', label: 'Course', required: true, type: 'string' },
  { key: 'teacher', label: 'Teacher', required: true, type: 'string' },
  { key: 'subject', label: 'Subject', required: true, type: 'string' },
  {
    key: 'numberOfQuestions',
    label: 'Total Number Of Questions',
    required: true,
    type: 'number',
  },
  { key: 'startDate', label: 'Start Date', required: true, type: 'date' },
  { key: 'dueDate', label: 'Due Date', required: true, type: 'date' },
  { key: 'remarks', label: 'Remarks', required: false, type: 'string' },
];

export const ASSIGNMENT_QUESTIONS_CONFIG: TemplateColumnConfig[] = [
  { key: 'title', label: 'Question Title', required: true, type: 'string' },
  { key: 'fullText', label: 'Full Text', required: false, type: 'string' },
  { key: 'category', label: 'Category', required: false, type: 'string' },
];

export const EXAM_TEMPLATE_CONFIG: TemplateColumnConfig[] = [
  { key: 'name', label: 'Exam Name', required: true, type: 'string' },
  { key: 'teachers', label: 'Teachers', required: true, type: 'string' },
  {
    key: 'examTime',
    label: 'Exam Time (minutes)',
    required: true,
    type: 'number',
  },
  { key: 'startDate', label: 'Start Date', required: true, type: 'date' },
  { key: 'deadlineDate', label: 'Deadline Date', required: true, type: 'date' },
  {
    key: 'isPublish',
    label: 'Is Published',
    required: true,
    type: 'enum',
    enumValues: ['Yes', 'No'],
  },
  {
    key: 'totalMarks',
    label: 'Total Marks (Auto-calculated)',
    required: false,
    type: 'number',
  },
  {
    key: 'totalQuestions',
    label: 'Total Questions (Auto-calculated)',
    required: false,
    type: 'number',
  },
];

export const EXAM_SECTION_CONFIG: TemplateColumnConfig[] = [
  { key: 'sectionName', label: 'Section Name', required: true, type: 'string' },
  { key: 'subject', label: 'Subject', required: true, type: 'string' },
  {
    key: 'numberOfQuestions',
    label: 'Number of Questions',
    required: true,
    type: 'number',
  },
  {
    key: 'marksForCorrect',
    label: 'Marks for Correct Answer',
    required: true,
    type: 'number',
  },
  {
    key: 'marksForIncorrect',
    label: 'Marks for Incorrect Answer',
    required: true,
    type: 'number',
  },
  {
    key: 'sectionTotalMarks',
    label: 'Section Total Marks (Auto-calculated)',
    required: false,
    type: 'number',
  },
];

export const EXAM_SECTION_QUESTIONS_CONFIG: TemplateColumnConfig[] = [
  { key: 'sectionName', label: 'Section Name', required: true, type: 'string' },
  { key: 'title', label: 'Question Title', required: true, type: 'string' },
  { key: 'fullText', label: 'Full Text', required: false, type: 'string' },
  { key: 'category', label: 'Category', required: false, type: 'string' },
];

export const EXAM_ADD_NEW_QUESTIONS_CONFIG: TemplateColumnConfig[] = [
  { key: 'sectionName', label: 'Section Name', required: true, type: 'string' },
  ...QUESTION_TEMPLATE_CONFIG,
];
